module.exports = __webpack_public_path__ + "img/card-satellite-rivoneed.13fbd5bd.webp";